import { generateLabelsAndValues } from "../utils/HelperFunctions";

export const AppealStatus = {
  PENDING: 1,
  APPROVED: 2,
  REJECTED: 3,
  PENDING_FOR_APPEAL_BOARD_DECISION:4
};

export const AppealStatusLabelandValues = generateLabelsAndValues(AppealStatus);

export const PreferredRegistration = {
  GRADUATE_TECHNOLOGIST: 1,
  QUALIFIED_TECHNICIAN: 2,
};

export const TECHNICAL_TECHNOLOGICAL_SERVICES_GT = {
  PRODUCT_DEVELOPMENT: 1,
  PRODUCT_MANUFACTURING: 2,
  PRODUCT_TESTING: 3,
  PRODUCT_COMMISSIONING: 4,
  PRODUCT_MAINTENANCE: 5,
};

export const TECHNICAL_TECHNOLOGICAL_SERVICES_QT = {
  PRODUCT_TESTING_TECHNICIAN: 6,
  PRODUCT_COMMISSIONING_TECHNICIAN: 7,
  PRODUCT_MAINTENANCE_TECHNICIAN: 8,
};

export const TechTechnoServicesGTLabelsAndValues = generateLabelsAndValues(
  TECHNICAL_TECHNOLOGICAL_SERVICES_GT
);

export const TechTechnoServicesQTLabelsAndValues = generateLabelsAndValues(
  TECHNICAL_TECHNOLOGICAL_SERVICES_QT
);
